import { createAction } from '@reduxjs/toolkit';
import { createPromiseAction } from 'app/utils/promiseActions';
const prefix = 'webSocket';
export const websocketActions = {
    request: createPromiseAction(`${prefix}/request`),
    requestFulfilled: createAction(`${prefix}/request/fulfilled`),
    requestRejected: createAction(`${prefix}/request/rejected`),
    requestSent: createAction(`${prefix}/requestSent`),
    create: createPromiseAction(`${prefix}/create`),
    createFulfilled: createAction(`${prefix}/createFulfilled`),
    createRejected: createAction(`${prefix}/create/rejected`),
    close: createAction(`${prefix}/close`),
    reconnectAttempt: createAction(`${prefix}/reconnectAttempt`),
    replyReceived: createAction(`${prefix}/replyReceived`),
    eventReceived: createAction(`${prefix}/eventReceived`),
    errorReceived: createAction(`${prefix}/errorReceived`),
    closeReceived: createAction(`${prefix}/closeReceived`),
    cancelReconnect: createAction(`${prefix}/cancelReconnect`),
    reconnectFailed: createAction(`${prefix}/reconnectFailed`),
    connectionPrimary: createAction(`${prefix}/connectionPrimary`),
};
